import React from "react";
import CustomPicky from "./CustomPicky";

const AuditOptions = ({
  currentPage,
  selectedAuditOption,
  onSelectAuditOption,
}) => {
  const isHoursPage = currentPage === "Hours";
  const options = isHoursPage
    ? [
        { label: "Original", value: 1 },
        { label: "Final", value: 2 },
        { label: "Comparison", value: 3 },
      ]
    : [
        { label: "Original", value: 1 },
        { label: "Final", value: 2 },
      ];
  const selected = !isHoursPage
    ? selectedAuditOption.value === 3
      ? options[0]
      : selectedAuditOption
    : selectedAuditOption;

  return (
    !currentPage !== "Dashboard" && (
      <CustomPicky
        key={`audit-${selected?.value || "none"}-${currentPage}`}
        className="picky_audit"
        options={options}
        value={selected}
        multiple={false}
        onChange={(val) => onSelectAuditOption(val)}
        placeholder="Select audit option"
      />
    )
  );
};

export default AuditOptions;
